import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, Wrench, Sparkles, Stethoscope, Baby, Siren, ArrowUpRight } from 'lucide-react';
import { services } from '../../mock';

const iconMap = { ShieldCheck, Wrench, Sparkles, Stethoscope, Baby, Siren };

export default function ServicesSection({ compact = false }) {
  return (
    <section className="relative bg-[#EFE9DF] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="reveal">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#8B7355]" />
              <span className="text-[10px] tracking-[0.32em] uppercase text-[#8B7355]">Our services</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-[#0B0B0B] leading-[1.05] max-w-2xl">
              Care that fits <span className="italic text-[#B69463]">every</span> stage of life.
            </h2>
          </div>
          <p className="text-[#0B0B0B]/70 max-w-md text-base leading-relaxed reveal">
            From your first cleaning to full smile design, our team offers comprehensive dentistry with a warm, personalized touch.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = iconMap[s.icon] || ShieldCheck;
            return (
              <Link
                key={s.id}
                to={`/services/${s.id}`}
                className="card-hover group bg-[#FAF7F2] border border-[#0B0B0B]/10 p-8 flex flex-col justify-between h-full reveal"
                style={{ transitionDelay: `${i * 80}ms` }}
              >
                <div>
                  <div className="flex items-start justify-between mb-8">
                    <div className="w-14 h-14 rounded-full border border-[#0B0B0B]/30 flex items-center justify-center">
                      <Icon size={22} strokeWidth={1.4} className="text-[#0B0B0B]" />
                    </div>
                    <span className="num-badge text-2xl">0{i + 1}</span>
                  </div>
                  <h3 className="font-display text-2xl text-[#0B0B0B] leading-tight">{s.title}</h3>
                  <p className="mt-3 text-sm text-[#0B0B0B]/70 leading-relaxed">{s.short}</p>
                </div>
                <div className="mt-8 flex items-center justify-between">
                  <span className="text-[10px] tracking-[0.28em] uppercase text-[#0B0B0B]">Explore {s.title}</span>
                  <ArrowUpRight size={18} strokeWidth={1.4} className="text-[#0B0B0B] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500" />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
